/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: k4MoYHGY6d3NVAoA3aDDg2
// Component: 85v3xQqbLXcE

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import Layout2 from "../../Layout2"; // plasmic-import: KxFKYkrIRubG/component
import { SideEffect } from "@plasmicpkgs/plasmic-basic-components";
import { LoginForm } from "@/components/LoginForm"; // plasmic-import: KuD93cbVtxox/codeComponent
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: k4MoYHGY6d3NVAoA3aDDg2/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: k4MoYHGY6d3NVAoA3aDDg2/styleTokensProvider


import sty from "./PlasmicAccount.module.css"; // plasmic-import: 85v3xQqbLXcE/css

const emptyProxy: any = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q: any): any {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export type PageCtx = {
  pageRoute: string;
  pagePath: string;
  params: Record<string, string | string[] | undefined>;
  query: Record<string, string | string[] | undefined>;
};

export function generateDynamicMetadata($q: any, $ctx: PageCtx) {
  return {
    openGraph: {},
    twitter: {
      card: "summary" as const
    }
  };
}

createPlasmicElementProxy;

export type PlasmicAccount__VariantMembers = {};
export type PlasmicAccount__VariantsArgs = {};
type VariantPropType = keyof PlasmicAccount__VariantsArgs;
export const PlasmicAccount__VariantProps = new Array<VariantPropType>();

export type PlasmicAccount__ArgsType = { isLogged?: boolean };
type ArgPropType = keyof PlasmicAccount__ArgsType;
export const PlasmicAccount__ArgProps = new Array<ArgPropType>("isLogged");

export type PlasmicAccount__OverridesType = {
  root?: Flex__<"div">;
  layout2?: Flex__<typeof Layout2>;
  section?: Flex__<"section">;
  sideEffect?: Flex__<typeof SideEffect>;
  h1?: Flex__<"h1">;
  supabaseLoginLogoutForm?: Flex__<typeof LoginForm>;
};

export interface DefaultAccountProps {}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicAccount__RenderFunc(props: {
  variants: PlasmicAccount__VariantsArgs;
  args: PlasmicAccount__ArgsType;
  overrides: PlasmicAccount__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          isLogged: false
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const $globalActions = useGlobalActions?.();

  const pageMetadata = generateDynamicMetadata(
    wrapQueriesWithLoadingProxy({}),
    $ctx as PageCtx
  );

  const styleTokensClassNames = _useStyleTokens();

  return (
    <React.Fragment>
      <Head></Head>

      <style>{`
        body {
          margin: 0;
        }
      `}</style>

      <div className={"plasmic_page_wrapper"}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            "all",
            "root_reset_k4MoYHGY6d3NVAoA3aDDg2",
            "plasmic_default_styles",
            "plasmic_mixins",
            styleTokensClassNames,
            sty.root
          )}
        >
          <Layout2
            data-plasmic-name={"layout2"}
            data-plasmic-override={overrides.layout2}
            className={classNames("__wab_instance", sty.layout2, {
              [sty.layout2global_locale_spanish]: hasVariant(
                globalVariants,
                "locale",
                "spanish"
              )
            })}
          >
            <section
              data-plasmic-name={"section"}
              data-plasmic-override={overrides.section}
              className={classNames("all", sty.section)}
            >
              {(
                hasVariant(globalVariants, "screen", "mobileOnly")
                  ? true
                  : false
              ) ? (
                <SideEffect
                  data-plasmic-name={"sideEffect"}
                  data-plasmic-override={overrides.sideEffect}
                  className={classNames("__wab_instance", sty.sideEffect)}
                  onMount={async () => {
                    const $steps = {};

                    $steps["invokeGlobalAction"] = true
                      ? (() => {
                          const actionArgs = {
                            args: [
                              "info",
                              "\u2196 Remember to press \u2261 to open the menu",
                              undefined,
                              undefined,
                              "topLeft"
                            ]
                          };
                          return $globalActions[
                            "plasmic-antd5-config-provider.showNotification"
                          ]?.apply(null, [...actionArgs.args]);
                        })()
                      : undefined;
                    if (
                      $steps["invokeGlobalAction"] != null &&
                      typeof $steps["invokeGlobalAction"] === "object" &&
                      typeof $steps["invokeGlobalAction"].then === "function"
                    ) {
                      $steps["invokeGlobalAction"] =
                        await $steps["invokeGlobalAction"];
                    }
                  }}
                />
              ) : null}
            </section>
            <h1
              data-plasmic-name={"h1"}
              data-plasmic-override={overrides.h1}
              className={classNames(
                "all",
                "h1",
                "h1__k4MoY",
                "__wab_text",
                sty.h1,
                {
                  [sty.h1global_locale_spanish]: hasVariant(
                    globalVariants,
                    "locale",
                    "spanish"
                  )
                }
              )}
            >
              {hasVariant(globalVariants, "locale", "spanish")
                ? "Cuenta"
                : "Account"}
            </h1>
            <LoginForm
              data-plasmic-name={"supabaseLoginLogoutForm"}
              data-plasmic-override={overrides.supabaseLoginLogoutForm}
              className={classNames(
                "__wab_instance",
                sty.supabaseLoginLogoutForm
              )}
              defaultEmail={""}
              defaultPassword={""}
              previewAsLoggedIn={false}
              successRedirectUrl={"/account"}
            />
          </Layout2>
        </div>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "layout2",
    "section",
    "sideEffect",
    "h1",
    "supabaseLoginLogoutForm"
  ],
  layout2: [
    "layout2",
    "section",
    "sideEffect",
    "h1",
    "supabaseLoginLogoutForm"
  ],
  section: ["section", "sideEffect"],
  sideEffect: ["sideEffect"],
  h1: ["h1"],
  supabaseLoginLogoutForm: ["supabaseLoginLogoutForm"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  layout2: typeof Layout2;
  section: "section";
  sideEffect: typeof SideEffect;
  h1: "h1";
  supabaseLoginLogoutForm: typeof LoginForm;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicAccount__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicAccount__VariantsArgs;
    args?: PlasmicAccount__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicAccount__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicAccount__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicAccount__ArgProps,
          internalVariantPropNames: PlasmicAccount__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicAccount__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicAccount";
  } else {
    func.displayName = `PlasmicAccount.${nodeName}`;
  }
  return func;
}

export const PlasmicAccount = Object.assign(
  // Top-level PlasmicAccount renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    layout2: makeNodeComponent("layout2"),
    section: makeNodeComponent("section"),
    sideEffect: makeNodeComponent("sideEffect"),
    h1: makeNodeComponent("h1"),
    supabaseLoginLogoutForm: makeNodeComponent("supabaseLoginLogoutForm"),

    // Metadata about props expected for PlasmicAccount
    internalVariantProps: PlasmicAccount__VariantProps,
    internalArgProps: PlasmicAccount__ArgProps,

    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/account",
      pagePath: "/account",
      params: {},
      query: {}
    })
  }
);

export default PlasmicAccount;
/* prettier-ignore-end */
